import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  ChangePasswordPageComponent,
  MainLayoutComponent
} from './core/containers';
import { NotLoggedInGuard } from '@ml/auth/guards';

import * as coreGuards from './core/guards';
import { AdminGuard } from './core/guards';
import { NotFoundComponent } from '@ml/core/components/not-found/not-found.component';
import { CustomPreloadingStrategy } from './custom-preloading.strategy';
import { EmployeeGuard } from '@ml/core/guards/employee.guard';
import { CustomerGuard } from '@ml/core/guards/customer.guard';
import { AdminPhoneGuard } from '@ml/core/guards/admin-phone.guard';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [coreGuards.AuthGuard],
    children: [
      {
        path: 'machineries',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import('./machineries/machineries.module').then(
            m => m.MachineriesModule
          )
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./orders/orders.module').then(m => m.OrdersModule),
        canActivate: [AdminGuard]
      },
      {
        path: 'customers',
        loadChildren: () =>
          import('./customers/customers.module').then(m => m.CustomersModule),
        canActivate: [AdminGuard]
      },
      {
        path: 'suppliers',
        loadChildren: () =>
          import('./suppliers/suppliers.module').then(m => m.SuppliersModule),
        canActivate: [AdminGuard]
      },
      {
        path: 'services',
        loadChildren: () =>
          import('./services/services.module').then(m => m.ServicesModule),
        canActivate: [AdminGuard]
      },
      {
        path: 'accounting',
        loadChildren: () =>
          import('./accounting/accounting.module').then(
            m => m.AccountingModule
          ),
        canActivate: [AdminGuard]
      },
      {
        path: 'employees',
        loadChildren: () =>
          import('./employees/employees.module').then(m => m.EmployeesModule),
        canActivate: [AdminGuard]
      },
      {
        path: 'tasks',
        loadChildren: () =>
          import('./tasks/tasks.module').then(m => m.TasksModule),
        data: { preload: true },
        canActivate: [EmployeeGuard]
      },
      {
        path: 'salaries',
        loadChildren: () =>
          import('./salaries/salaries.module').then(m => m.SalariesModule),
        data: { preload: true },
        canActivate: [EmployeeGuard]
      },
      {
        path: 'customer-orders',
        loadChildren: () =>
          import('./customer-orders/customer-orders.module').then(
            m => m.CustomerOrdersModule
          ),
        canActivate: [CustomerGuard]
      },
      {
        path: 'locations',
        loadChildren: () =>
          import('./locations/locations.module').then(m => m.LocationsModule),
        canActivate: [CustomerGuard]
      },
      {
        path: '',
        pathMatch: 'full',
        canActivate: [AdminPhoneGuard],
        children: []
      }
    ]
  },
  {
    path: 'auth',
    canActivate: [NotLoggedInGuard],
    loadChildren: './auth/auth.module#AuthModule'
  },
  {
    path: 'change-password',
    // canActivate: [FirstTimeLoginGuard],
    component: ChangePasswordPageComponent
  },
  { path: '**', redirectTo: 'not-found', pathMatch: 'full' },
  { path: 'not-found', component: NotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: CustomPreloadingStrategy
    })
  ],
  exports: [RouterModule],
  providers: [CustomPreloadingStrategy]
})
export class AppRoutingModule { }
